<div class="wallboardViewSlide" [attr.mid]="moduleKey" [ngStyle]="{ 'background-image': 'url(../Admin/ImageResizer.aspx?imgid=' + backgroundID + '&w=1920&h=1080)' }" ngCloak>
    <div [ngStyle]="!hasBackdrop ? { 'box-sizing': 'content-box' } : {}"
         [ngClass]="hasBackdrop ? 'wallboardViewSlideContentAreaDark dynamic-scaling' : 'wallboardViewSlideContentAreaLight dynamic-scaling'"
         [style.--item-count]="itemCount">
        <div class="leaderboardHeader leaderboardTitleResponsive">{{leaderboardState?.LeaderboardTitle}} - {{leaderboardMetricName}}</div>
        <div class="leaderboardContent">
            <div class="leaderboardContentLeft">
                <div class="lRowHighlight"></div>
                <div class="leaderboard-list dynamic-scaling" [style.--item-count]="itemCount">
                    <div class="leaderboardRow" *ngFor="let item of leaderboardData; let i = index">
                        <div [id]="'pos' + i" class="lPosition leaderboardRowTextResponsive">
                            {{displayPosition(i)}}
                        </div>

                        <div [id]="'name' + i" class="lName txtOverflow leaderboardRowTextResponsive">
                            {{item.groupName}}
                        </div>

                        <div [id]="'data' + i" class="lMetricData leaderboardRowTextResponsive">
                            {{item.metricData.MetricDisplayValue}}
                        </div>
                    </div>
                </div>
            </div>

            <div class="leaderboardContentRight">
                <div class="lImageBackground" *ngIf="!config.isCxOne">
                    <div class="lImage" style="width:89%; height:89%; background-position:center; background-repeat:no-repeat"
                         [ngStyle]="{ 'background-image': getUserImage(selectedAgent), 'background-size': getBackgroundSize() }"></div>
                </div>

                <div class="lImageBackground" *ngIf="config.isCxOne">
                    <div *ngIf="selectedAgent <= 2" class="lImage"
                         style="display: flex; align-items: center; justify-content: center; width:89%; height:89%;
                            background-position:center; background-repeat:no-repeat; overflow: hidden;">
                        <svg *ngIf="getIconUrl(selectedAgent)" width="50%" height="50%">
                            <use [attr.href]="getIconUrl(selectedAgent)"></use>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
